import { PosVendors } from 'utils/vendor-config';

import { VendorVariables } from './picker-batched-query-types';

/**
 * Builds the boolean vendor variables for vendor-filtered picker queries.
 * Only the variable matching the current POS vendor will be true,
 * ensuring the GraphQL response only includes that vendor's config data.
 *
 * @example
 * // For an NCR pickup store:
 * buildVendorVariables('ncr')
 * // => { isCarrols: false, isCarrolsDelivery: false, isNcr: true, ... }
 */
export const buildVendorVariables = (vendor: PosVendors | null): VendorVariables => ({
  isCarrols: vendor === PosVendors.CARROLLS,
  isCarrolsDelivery: vendor === PosVendors.CARROLS_DELIVERY,
  isNcr: vendor === PosVendors.NCR,
  isNcrDelivery: vendor === PosVendors.NCR_DELIVERY,
  isQdi: vendor === PosVendors.QDI,
  isQdiDelivery: vendor === PosVendors.QDI_DELIVERY,
});
